import React, { useState } from "react";
import taService from "../services/ta.service";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import {
  currencyToNumber,
  indianCurrencyFormater,
} from "../../../../helpers/functions/currencyFormater";
import Swal from "sweetalert2";

export default function useLOSApplicationId(active) {
  const {
    id,
    losApplicationId,
    estCreditLimit,
    losRequestDate,
    personName,
    userState,
    crif_report,
  } = active;
  const initialValue = {
    los_application_id: losApplicationId ? losApplicationId : "",
    ta_credit_limit: "",
    ta_agreement_Data: "",
    losRequestDate: losRequestDate ? losRequestDate : "",
    estCreditLimit: estCreditLimit ? estCreditLimit : "",
    crif_report_link: crif_report ? crif_report : "",
  };
  const [formData, setFormData] = useState(initialValue);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [modal, setModal] = useState(false);

  const handleSubmitLOSApplicationId = async (e) => {
    try {
      e.preventDefault();
      setButtonLoader(true);
      const form_data = new FormData();
      form_data.append("taOnboardingCaseId", id);
      if (formData?.ta_agreement_Data && formData?.ta_credit_limit) {
        form_data.append("creditLimit", formData?.ta_credit_limit);
        form_data.append("agreementDate", formData?.ta_agreement_Data);
      }
      form_data.append("losApplicationId", formData?.los_application_id);
      form_data.append("losRequestDate", formData?.losRequestDate);
      form_data.append("estCreditLimit", formData?.estCreditLimit);
      const response = await taService.UpdateLOSApplicationId(form_data);
      if (response.status === 200) {
        setButtonLoader(false);
        successToast(response.msg);
        window.location.reload();
      } else {
        setButtonLoader(false);
        errorToast(response.msg);
      }
    } catch (error) {
      console.error(error);
      errorToast(error?.message);
    } finally {
      setButtonLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ta_credit_limit") {
      const numericValue = currencyToNumber(value);
      setFormData((prev) => ({
        ...prev,
        [name]: indianCurrencyFormater(numericValue),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleUpload = async (e, name) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;

      const header = "Crif Report";
      const fileURL = URL.createObjectURL(file);
      const fileType = file.type;
      let filePreviewHTML = "";
      if (fileType === "application/pdf") {
        filePreviewHTML = `<iframe src="${fileURL}" width="100%" height="400px" style="border:1px solid #ccc;"></iframe>`;
      } else if (fileType.startsWith("image/")) {
        filePreviewHTML = `<img src="${fileURL}" style="max-width:100%; max-height:400px; border:1px solid #ccc;" />`;
      } else if (
        file.name.endsWith(".doc") ||
        file.name.endsWith(".docx") ||
        fileType === "application/msword" ||
        fileType ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        filePreviewHTML = `<p><a href="${fileURL}" target="_blank">Click here to preview the DOC file</a></p>`;
      } else {
        filePreviewHTML = `<p>File preview not supported. Click "Upload" to continue.</p>`;
      }
      const result = await Swal.fire({
        title: "Confirm Upload",
        html: `
            <p>You are about to upload: <strong>${file.name} for ${header}</strong></p>
            ${filePreviewHTML}
          `,
        showCancelButton: true,
        confirmButtonText: "Yes, Upload it!",
        cancelButtonText: "Cancel",
        width: 600,
        heightAuto: false,
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();
          formData.append("taOnboardingCaseId", id);
          formData.append(name, file);

          try {
            const response = await taService.UploadDoc(formData);
            if (response?.status === 200) {
              successToast(response?.msg);
              setFormData((prev) => ({
                ...prev,
                ["crif_report_link"]: response?.link,
              }));
            } else {
              errorToast(response?.msg);
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
      });

      if (!result.isConfirmed || !result.value) {
        e.target.value = null;
        URL.revokeObjectURL(fileURL);
        return;
      }

      URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Upload error:", error);
      errorToast("An error occurred during upload.");
    }
  };

  const handleSendEmail = (value) => {
    const emailData = {
      to: "",
      cc: "",
      subject: ``,
      body: `Dear Team,
Successfully logged-in Application ID ${losApplicationId}. Also attached CRIF report for your reference.
Name of Applicant - ${personName}
State - ${userState}
Regards,
Snehal.`,
    };

    navigator.clipboard
      .writeText(emailData?.body)
      .then(() => {
        successToast("Link copied to clipboard");
      })
      .catch((err) => {
        errorToast(err);
      });
    openOutlookEmail(emailData);
  };

  const openOutlookEmail = ({ to, cc, subject, body }) => {
    const mailtoLink = `mailto:${encodeURIComponent(
      to
    )}?cc=${encodeURIComponent(cc)}&subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return {
    formData,
    setFormData,
    buttonLoader,
    setButtonLoader,
    handleSubmitLOSApplicationId,
    handleChange,
    handleUpload,
    handleSendEmail,
  };
}
